module.exports = "\r\n.searchbar{\r\n    background-color: black;\r\n    padding: 10px 0px;\r\n}\r\n.searchbar label{\r\n    color: white;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/internal-users/internal-users-grid/internal-users-grid.component.css
// module id = ./src/app/masters/internal-users/internal-users-grid/internal-users-grid.component.css
// module chunks = main